export default {
  ERROR: 'ERRO 404',
  LOST: 'Ops! A página não foi encontrada!',
  NOT_FOUND: 'Por favor verifique se a url estão correta e tente novamente.',
  SEARCH_TEXT: 'Ou entre no site Homer para buscar seu imóvel',
  SEARCH: 'Buscar imóveis',
};
